module.exports = __webpack_public_path__ + "static/img/naturalCircle8h.42d97cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/naturalCircle8h.svg
// module id = hAWz
// module chunks = 1